import React from 'react';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer, Slide } from 'react-toastify';

import { queryClient } from '../config/queryClientConfig';
import { Toolbar } from '../components/Toolbar/Toolbar';

export interface AppRouterContext {
  unauthorizedUser: boolean;
}

const RootComponent = () => (
  <QueryClientProvider client={queryClient}>
    <ToastContainer position="top-right" transition={Slide} autoClose={4000} closeOnClick draggable={false} hideProgressBar pauseOnHover />
    <Toolbar />
    <Outlet />
  </QueryClientProvider>
);

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootComponent,
});
